<template>
    <v-card class="defaultCard" color="bgtopology">
        <span class="titlePages"> {{ t('title.allLatency')}} </span>

        <v-row v-if="showCard" class="ma-0 mr-2" :justify="smAndDown ? 'center' : 'end'">
            <v-btn-toggle divided color="#E84FC4" rounded="2" group variant="outlined"  >
                <v-btn size="small" class="btnSlidersDashboard" @click="changeData(TYPES.all)"> <span class="text_btns"> {{ t('labels.all') }}  </span>  </v-btn>
                <v-btn size="small" class="btnSlidersDashboard" @click="changeData(TYPES.distri)">  <span class="text_btns"> {{ t('labels.distribution') }}  </span>  </v-btn>
                <v-btn size="small" class="btnSlidersDashboard" @click="changeData(TYPES.client)"> <span class="text_btns"> {{ t('labels.client') }}   </span>  </v-btn>
                <v-btn size="small" class="btnSlidersDashboard" @click="changeData(TYPES.acceso)">  <span class="text_btns"> {{ t('labels.access') }}   </span>  </v-btn>
                <v-btn size="small" class="btnSlidersDashboard" @click="changeData(TYPES.down)"> <span class="text_btns"> {{ t('labels.down') }}    </span>  </v-btn>
            </v-btn-toggle>
        </v-row>
        <v-row v-if="finalTableItems.length > 0  && showCard" justify="space-between" class="ma-0 mb-4">
            <v-col v-for="(item,i ) in finalLegend" :key="i">
                <rangeComponent
                    :principal-color="item.prinColor "
                    :secundary-color="item.secuColor "
                    :color-text-princ="item.colorText1"
                    :color-text-secun="item.colorText2"
                    :principal-text="item.prinText"
                    :secundary-text="item.secuText"
                    />
            </v-col>
        </v-row>
        <EasyDataTable
        v-if="finalTableItems.length > 0  && showCard"
        header-text-direction="left"
        table-class-name="customize-table"
        show-index
        :headers="headertable"
        :items="finalTableItems"
        :rows-per-page="100"
        @click-row="showDialogWithType"
        >
            <template #item-ip ="item">
                <div style="width: 90px;">
                    <span> {{ item.ip }} </span>
                </div>
            </template>
            <template #item-latencia ="item">
                <v-row justify="space-between" style="align-items: center !important">
                    <v-col cols="2" class="pa-0"><span> {{ item.latencia }} </span></v-col>
                    <v-col cols="10" class="pa-0 pr-6">
                        <v-progress-linear
                        style="border-radius: 20px;"
                        :model-value="100"
                        height="10"
                        striped
                        :color="
                        item.latencia < 0 ? '#9E9E9E' : item.latencia <= 100 ? '#00FF00' : item.latencia <= 500 ? '#FFEE00' :'#FF0000'"
                    ></v-progress-linear>
                    </v-col>
                </v-row>
            </template>
        </EasyDataTable>
        <v-sheet v-if="showCircle" class="text-center" color="transparent">
            <Prog_circular />
        </v-sheet>
        <v-row  v-if="showError" class="ma-0 py-3">
            <h3> {{ t('noInformation')}} </h3>
        </v-row>
    </v-card>

    
    <!-- DIALOG COMPONENT -->
    <v-dialog v-model="dialog" width="85%">
        <DialogComponent
        v-if="dialog"
        :ip="selectedIp"
        :typeSel="selectedType"
        :name="selectedName"
        @dialog="closeDialog"
        />             
    </v-dialog>
</template>

<script setup lang="ts">
import { ref, computed, ComputedRef, onMounted, Ref } from 'vue';

/********************************
 ********** COMPONENTES *********
 *******************************/
import rangeComponent  from '@/components/SmartLink/dashboard/rangeComponent.vue';
import DialogComponent from '@/components/SmartLink/dialog/dialogComponent.vue';
import Prog_circular from '@/components/PrincipalComponents/Prog_circular.vue';

/********************************
 ************ I18N **************
 *******************************/
import { useI18n } from 'vue-i18n';
const { t } = useI18n();

/********************************
 ************ VUETIFY ***********
 *******************************/
import { useDisplay } from 'vuetify';
const { smAndDown } = useDisplay();

/********************************
 ************ STORE *************
 *******************************/
import { useStore } from 'vuex';
const store = useStore();

/********************************
 ********** CONSTANTES **********
 *******************************/
import { TYPES, LABELS, VISIBLE_PAGES } from '@/constants/labels';
import { FINAL_HEADERS_TABLE } from '@/constants/tableHeaders';
import { FINAL_TYPE_LEGEND } from '@/constants/legends';

/********************************
 ********** INTERFACES **********
 *******************************/
import { getAllLatencyData } from '@/services/Smartlink/KPI';
import { LATENCY } from '@/interfaces/SmartLink/Topology';
import { LEGEND } from '@/interfaces/SmartLink/General';



/**
 * Lista de todos los equipos, parte con la vista total, pero se pueden filtar
 */
const finalTableItems:Ref<LATENCY[]> = ref([]);

/**
 * Lista de todos los equipos filtrados
 */
const arrayTodos:Ref<LATENCY[]> = ref([]);

/**
 * Lista de todos los equipos con subtipo Acceso
 */
const arrayAcceso:Ref<LATENCY[]> = ref([]);

/**
 * Lista de todos los equipos con subtipo Distribución
 */
const arrayDistri:Ref<LATENCY[]> = ref([]);

/**
 * Lista de todos los equipos con subtipo Cliente
 */
const arrayClient:Ref<LATENCY[]> = ref([]);

/**
 * Lista de todos los equipos con estado Caído
 */
const arrayDowns:Ref<LATENCY[]>  = ref([]);

/**
 * Muestra el apartado de error, en vez de mostrar información o un espacio vacío. 
 * Generalmente es cuando desde la API no trae valores.
 */
const showError                         = ref(false);

/**
 * Mostrar los cards con info, si no tiene dato desde las API, oculta la tabla y los botones
 */
const showCard                          = ref(true);

/**
 * Mostrar el Loading
 */
const showCircle                        = ref(true);

async function getAllLatencies() {

     const allData = await getAllLatencyData()
        showError.value     = !allData.showGraphs;
        showCard.value      = allData.showGraphs;
        showCircle.value    = !allData.showGraphs;

        if( allData.status === 400 ){
            store.commit('showSnackBar', {type: LABELS.error, msg: t('snackbar.errorApis'), valor : true});
        }
        if( allData.status === 200 ){
            arrayTodos.value    = allData.data.all 
            arrayDistri.value   = allData.data.distri 
            arrayAcceso.value   = allData.data.acceso 
            arrayClient.value   = allData.data.client 
            arrayDowns.value    = allData.data.downs 
        }

        finalTableItems.value = arrayTodos.value
}

/**
 * Muestra los valores en las tablas, dependiendo del tipo de Familia
 * También se aplica para todos los equipos y los equipos caídos
 * @param value Tipo de familia, todos o los caídos
 */
function changeData(value:string) {
    value === TYPES.all     ? finalTableItems.value = arrayTodos.value  : null;
    value === TYPES.distri  ? finalTableItems.value = arrayDistri.value : null;
    value === TYPES.acceso  ? finalTableItems.value = arrayAcceso.value : null;
    value === TYPES.client  ? finalTableItems.value = arrayClient.value : null;
    value === TYPES.down    ? finalTableItems.value = arrayDowns.value  : null;
}

/**
 * Mostrar el Dialogo
 */
 const dialog        = ref(false);

/**
 * IP del equipo Seleccionado de la tabla para mostrar en el DIÁLOGO
 */
const selectedIp    = ref('');

/**
 * Nombre del equipo Seleccionado de la tabla para mostrar en el DIÁLOGO
 */
const selectedName  = ref('');

/**
 * Tipo del equipo Seleccionado de la tabla para mostrar en el DIÁLOGO
 */
const selectedType  = ref('');

/**
 * Captura toda la información del elemento seleccionado en la tabla
 * y se almacenan los valores de (ip, tipo, nombre, marca, estado) en las variables correspondientes
 * para luego abrir el dialog con la información gráfica y estadística del equipo en cuestión
 * @param item La fila seleccionada en la tabla
 */
function showDialogWithType(item: LATENCY) {
    selectedIp.value        = item.ip;
    selectedName.value      = item.name;
    selectedType.value      = item.tipo;
    dialog.value            = true
}

/**
 * Cierra el Diálogo mediante un EMIT del componente de Dialogo
 */
function closeDialog (){
    dialog.value = false;
}

/**
 * Captura de la Constante el tipo de Cabecera de Tabla que tiene, dependiendo del valor de la vista seleccionada
 */
const headerLatency = FINAL_HEADERS_TABLE[VISIBLE_PAGES.latency];

/**
 * Valor de los HEADERS Seleccionados, solo que no se realiza aquí la petición por errores en el Front.
 * Una vez ya se hace el pedido a la API, recién se captura dicha cabecera de tabla
 */
const headertable   = ref(headerLatency);

/**
 * Captura de la Constante el tipo de Leyenda que tiene, dependiendo del valor de la vista seleccionada
 */
 const legend:ComputedRef<LEGEND[]>      = computed(() => FINAL_TYPE_LEGEND['latency']);

/**
 * Valor de la Legenda Seleccionada, solo que no se realiza aquí la petición por errores en el Front.
 * Una vez ya se hace el pedido a la API, recién se captura dicha leyenda
 */
const finalLegend                       = ref(legend.value);

onMounted(() => {
    getAllLatencies()  
})

</script>